import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BaseApi} from "@shared/base/base-api";
import {QuotationRelation} from "@app/quotation/shared/quotation-relation";

@Injectable({
  providedIn: 'root'
})
export class QuotationRelationApi extends BaseApi<QuotationRelation> {
  protected readonly httpClient: HttpClient;

  constructor() {
    const httpClient = inject(HttpClient);

    super(httpClient, 'quotation-relations');
  
    this.httpClient = httpClient;
  }

  create(): QuotationRelation {
    return new QuotationRelation();
  }
}
